import React, { Component, Fragment } from 'react';
import { Body, Title, Micro } from '@vds/typography';
import { RadioBoxGroup } from '@vds/inputs';
import { PricingLockup } from '@vds/type-lockups';
import styled from 'styled-components';
import './CBandPlan.css'

const MarginSpacerM = styled.div`margin-top: 1rem !important;`;



class CBandPlanPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showPlanDetailsIndex:[],
            endInteraction: false,
        }
        this.renderRadioBox = this.renderRadioBox.bind(this)
    }
    componentDidMount() {
        this.setState({ endInteraction: true });
    }

    componentDidUpdate = () => {
        if(this.state.endInteraction && navigator?.userAgentData?.platform !== "macOS") {
            window.newrelic.interaction().end();
            this.setState({ endInteraction: false });
        }
    }

    renderRadioBox() {
        const dataFor4G = [{
            productName: '100 Mbps Speed',
            price: '69',
            productDesc: 'Supports the use of local apps, email, Wi-Fi connected devices and basic guest Wi-Fi.',
            planDetails: [{ name: 'Do-it-yourself setup', tooltip: null }
            // , { name: '10-year price guarantee*', tooltip: null }, { name: 'Get up to a $1,500 credit to help cover early termination fees when you switch ', tooltip: '' }
        ],
            discount: null
        },
        {
            productName: '200 Mbps Speed',
            price: '99',
            productDesc: 'Enables heavy video conferencing, webinar hosting, cloud-based apps and high-volume guest Wi-Fi.',
            planDetails: [{ name: 'Do-it-yourself setup', tooltip: null }
            // , { name: '10-year price guarantee*', tooltip: null }, { name: 'Get up to a $1,500 credit to help cover early termination fees when you switch ', tooltip: '' }
        ],
            discount: '$99 one time discount.'

        }]
        if(this.props.fiveGQualified!==null&&this.props.fiveGQualified&&this.props.fiveGQualified==='Y'){
            dataFor4G.push({
                productName: '400 Mbps Speed',
                price: '199',
                productDesc: 'Accomodates heavy cloud app usage, streaming media and advanced devices and robotics.',
                planDetails: [{ name: 'Professional Install', tooltip: null }],
                discount: '$199 one time discount.'
    
            })
        }

        let list = []
        dataFor4G.map((value,j)=>{
            let eachObject = {
                id: `product` + j,
                // text: '100 Mbps Speed',
                type: 'radiobox',
                width: '100%',
                subtext: '',
                children: (
                    <React.Fragment>
                        <>
                            <div className="fg-Box">
                                <div className="fg-Box-Title" style={{ minHeight: '60px' }}>
                                    <Title size="large" viewport="mobile" primitive="h1">
                                        {value.productName}
                                    </Title>
                                </div>
                                <div className="fg-Box-Prise" style={{ borderBottom: "1px solid #000" }}>
                                    <div style={{ marginBottom: '1rem' }}>
                                        <div class="fg-Joint-Offer">
                                            <PricingLockup
                                                price={value.price}
                                                labelBottom={<div className='font-size-11'>/mo</div>}
                                            />
                                        </div>
                                        <Micro primitive="h2" className="bottom-text">
                                            <div className='font-size-11'>{'Plus taxes, fees & equip. charges.'} </div>
                                        </Micro >
                                    </div>
                                    {this.props.hasMultipleAddress ?this.props.hasMultipleAddress&&!this.state.showPlanDetailsIndex.includes(j)?
                                    <div className='expand-plan'>
                                        <span onClick = {()=>{
                                                document.getElementById(`product${j}`).style.height = '100%'
                                                let dataIndex = this.state.showPlanDetailsIndex
                                                dataIndex.push(j)
                                                this.setState({showPlanDetailsIndex:dataIndex})
                                                }}>+</span>
                                        </div>:this.props.hasMultipleAddress&&this.state.showPlanDetailsIndex.includes(j)?
                                        <div className='expand-plan'>
                                        <span onClick = {()=>{
                                            document.getElementById(`product${j}`).style.height = 'auto'
                                            let dataIndex = this.state.showPlanDetailsIndex.filter(val=>val!==j)
                                            console.log(dataIndex,'sdfsdfdsfsd')
                                            this.setState({showPlanDetailsIndex:dataIndex})
                                            }}>-</span>
                                    </div>
                                        :null:null}
                                </div>
                                {(this.props.hasMultipleAddress && this.state.showPlanDetailsIndex.includes(j))||!this.props.hasMultipleAddress? <div>
                                    <div>
                                        <MarginSpacerM>
                                            <Body size="small" viewport="desktop" primitive="h2" style={{ paddingTop: '19px', fontSize: '12px!important', lineHeight: '1.21' }}>
                                                <div className='font-size-12 ht-40'> {value.productDesc}</div>
                                            </Body>
                                        </MarginSpacerM>
                                    </div>
                                    <div className="fg-Box-Plans">
                                        <Body size="medium" primitive="h1" bold className="font-size-12">Plan details</Body>
                                        <div className="fg-Box-offertext-white-wrapper">
                                            {value.planDetails.map(data => (
                                                <div className="fg-Box-offertext list-items">
                                                    <Body size="medium">
                                                        <div className='font-size-12 line-ht-2'>{data.name}</div>
                                                    </Body>
                                                </div>
                                            ))}

                                        </div>

                                    </div>
                                    {/* <Body size="medium">
                                        <div className='font-size-12 line-ht-2 fg-Box-discount'>{value.discount}</div>
                                    </Body>                                 */}
                                </div>:null}

                            </div>

                        </>
                    </React.Fragment>
                )
            }
            list.push(eachObject);

        })
        return list
    }

    render() {
        return (
            <div>
                <div className='header-4g'>
                    <Title size="medium">
                        Great news! 5G Business Internet is available.
                    </Title>
                    <Body size="small">Get fast speed with unlimited data to optimize your business network.</Body>
                </div>
                <div className='pad-bt-70'>
                    <RadioBoxGroup
                        childWidth={'100%'}
                        key={"BundlePlan"}
                        rowQuantity={{
                            mobile: 1,
                            desktop: 4,
                        }}
                        //selected={newId.toString()}
                        //onChange={(e) => { selectInternetService(e) }}
                        className={this.props.hasMultipleAddress ? `radio-box-grp-4g`:`radio-box-grp-4g-ma`}
                        data={this.renderRadioBox()}
                    />
                    </div>

            </div>
        )
    }
}
export default CBandPlanPage

